import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { environment } from '../../environments/environment';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { initializeAppCheck, provideAppCheck, ReCaptchaV3Provider } from '@angular/fire/app-check';
import {
  getFirestore,
  provideFirestore
} from '@angular/fire/firestore';
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { BrowserModule } from '@angular/platform-browser';
import { HomeComponent } from '../public/views/home/home.component';
import { CookiesPopupModule } from './components/cookies-popup/cookies-popup.module';
import { LayoutModule } from '../shared/components/layout/layout.module';
import { SharedModule } from '../shared/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { MatChipsModule } from '@angular/material/chips';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { getAnalytics, isSupported } from '@angular/fire/analytics';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MatDialogModule } from '@angular/material/dialog';

let resolvePersistenceEnabled: (enabled: boolean) => void;
export const persistenceEnabled = new Promise<boolean>(resolve => {
  resolvePersistenceEnabled = resolve;
});

const FIREBASE_MODULES = [
  provideAuth(() => getAuth()),
  provideFirebaseApp(() => {
    const app = initializeApp(environment.firebase);

    /** Google Analytics */
    isSupported().then((supported: boolean) => {
      if (supported) getAnalytics(app);
    });

    return app;
  }),
  provideAppCheck(() =>  {
      const provider = new ReCaptchaV3Provider(environment.recaptcha3SiteKey);
      return initializeAppCheck(undefined, { provider, isTokenAutoRefreshEnabled: true });
  }),
  provideFirestore(() => getFirestore()),
  provideStorage(() => getStorage()),
  provideFunctions(() => getFunctions())
];

const GLOBAL_ANGULAR_MATERIAL_MODULES = [
  MatSnackBarModule, MatDialogModule,
  MatButtonModule, MatIconModule, MatChipsModule, // HomeComponent
];

const GLOBAL_COMPONENTS = [HomeComponent];

const GLOBAL_MODULES = [
  CookiesPopupModule,
  LayoutModule,
  RouterModule,
  SharedModule
];

@NgModule({
  declarations: [...GLOBAL_COMPONENTS],
  imports: [
    BrowserModule.withServerTransition({ appId: 'anonymous-systems' }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    CommonModule,
    ...FIREBASE_MODULES,
    ...GLOBAL_ANGULAR_MATERIAL_MODULES,
    ...GLOBAL_MODULES
  ],
  exports: [
    ...GLOBAL_COMPONENTS,
    ...GLOBAL_MODULES
  ]
})
export class CoreModule { }
